export default __webpack_public_path__ + "static/media/webdev.d6595317.jpg";